export default "__VITE_ASSET__TGLjl$qZ__"